import withAccountMenuProps from 'viewModel/header/accountMenu/withAccountMenuProps';
import AccountMenu from 'components/Header/AccountMenu/AccountMenu';

export default withAccountMenuProps(AccountMenu);
